export default __webpack_public_path__ + "static/media/Bluenet Repeaters.de66784b.jpg";